import { NgModule } from "@angular/core";
import {TabViewModule} from 'primeng/tabview';
import {CheckboxModule} from 'primeng/checkbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {CalendarModule} from 'primeng/calendar';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {CarouselModule} from 'primeng/carousel';
import {SliderModule} from 'primeng/slider';
import {RadioButtonModule} from 'primeng/radiobutton';
import {ToastModule} from 'primeng/toast';
import { SkeletonModule } from "primeng/skeleton";
import { DialogModule } from 'primeng/dialog';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

@NgModule({
    exports :
    [  
      TabViewModule,
      CheckboxModule,
      MultiSelectModule,
      CalendarModule,
      DropdownModule,
      InputTextModule,
      CarouselModule,
      SliderModule,
      RadioButtonModule,
      ToastModule,
      SkeletonModule,
      DialogModule,
      NzPopoverModule
    ]
})
export class PrimeNGUIModules
{}
